import store from '../../../store'
import  general_register from './general_register.vue'

window.PWA_GENERATE=  new Vue({
    store,
    el: '#general_register',

    data () {
        return {

        }
    },
    created () {

    },
    components : {
        general_register
    }
});
